import React from 'react';
import { Cell, ColumnInterface } from 'react-table';
import _startCase from 'lodash/startCase';

import { pickColorFromRoleType } from '@trqk/utils';

const defaultCellWidth = 100;

interface RoleCellProps {
    cell: Cell<TrqkEntity>;
    column: ColumnInterface<TrqkEntity>;
}

/**
 * A react-table cell that renders the role_type for an entity, using the logic from
 * pickColorFromRoleType to style the role_type with a particular font color.
 * @param props {RoleCellProps}
 */
export function RoleCell({ cell, column }: RoleCellProps): JSX.Element {
    const width = (column?.width as number) ?? defaultCellWidth;
    const roleType: ProRoleType = cell.value;
    const colorGrade = pickColorFromRoleType(roleType);

    return (
        <div
            className={`respond-to-mouse truncate text-${colorGrade}-500 font-medium`}
            style={{
                width,
            }}
        >
            {_startCase(cell.value)}
        </div>
    );
}
